<p-sidebar 
  #historySidebar 
  id="history" 
  styleClass="chat-sidebar" 
  [(visible)]="historyVisible" 
  position="left"
  [modal]="false"
>
  <ng-template pTemplate="header">
    <div>
      <div class="flex-fill">
        <h4 class="text-center">Chat history</h4>
      </div>
      <div class="mt-1">
        <p-button pRipple
          icon="fa-regular fa-pen-to-square"
          label="Start new chat"
          [text]="true" severity="secondary"
          (onClick)="createNewChat()">
        </p-button>
      </div>
      <div class="mt-1">
        <p-button pRipple
          icon="pi pi-trash"
          label="Remove all chat history"
          [text]="true" severity="secondary"
          (onClick)="removeAllHistoryChat()"
          [disabled]="!history?.length">
        </p-button>
      </div>
    </div>
  </ng-template>

  <ng-container *ngIf="!loadingChatHistory;else spinnerTempl">
    <ng-container *ngIf="history?.length;else emptyTempl">
      <div *ngFor="let group of groupedHistory">
        <ng-container *ngIf="group.items.length">
          <div class="mt-3 history-order-label">{{group.label}}</div>
          <div *ngFor="let chat of group.items">
            <app-history-item
              [chat]="chat"
              [chatType]="chatType"
              [isCurrentChat]="isCurrentChatId(chat)"
              (load)="handleHistoryItemSelect($event)"
              (rename)="onChatRename($event)"
              (delete)="onChatHistoryItemDelete($event)"
              (pin)="onChatPinned($event)"
            ></app-history-item>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #spinnerTempl>
    <div class="d-flex">
      <div class="m-auto">
        <p-progressSpinner></p-progressSpinner>
      </div>
    </div>
  </ng-template>

  <ng-template #emptyTempl>
    <div class="mt-4">
      No chat history available
    </div>
  </ng-template>
</p-sidebar>
